import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import { useForm } from "react-hook-form";

import Header from "../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPerson, faWarehouse, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Button, Col, Row } from "react-bootstrap";
import Datepicker from "../../common/Datepicker";
import { getAllData } from "../../../utils/apis/lnvestorsledger/lnvestorsledger";
import { formatDate } from "../../../utils/common";
import ExportMethod from "../../../utils/apis/ExportMethod";
import Pagination from "../../common/Pagination";
import {
  getFundsData,
  getFundsUserData,
  getProfitUserData,
  getRefferalUserData,
  getUserData,
} from "../../../utils/apis/Report/Report";
import { getSetup } from "../../../utils/apis/masters/masters";
library.add(fas);

// *****************************************************************************************************

const UserWiseReport = () => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      from: "",
      to: "",
      service_number: "",
    },
  });

  const onSubmit = async (data) => {
    getData();
  };

  const [state, setState] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [city, setCity] = useState([]);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState();

  const [TotalEntries, setTotalEntries] = useState(1);
  const [TotalPages, setTotalPages] = useState(1);
  const [perPage, setperPage] = useState();

  const getData = async () => {
    const res = await getUserData(
      getValues("service_number"),
      getValues("from"),
      getValues("to"),
    );
    setData(res.data);
    setCurrentPage(res?.data?.currentPage);
    setperPage(res?.data?.per_page);
    setTotalEntries(res?.data?.totalEntries);
    setTotalPages(res?.data?.totalPages);
  };

  useEffect(() => {
    getData();
  }, []);

  //
  const handleExportFunds = async () => {
    const res = await getFundsUserData(
      data?.user_id,
      getValues("from"),
      getValues("to"),
    );

    const header = [
      { name: "Payment Date" },
      { name: "Investor Name" },
      { name: "Service No" },
      { name: "Fund Type" },
      { name: "UTR ID" },
      { name: "Amount" },
    ];

    // Use map without async, but await promises
    const exportData = await Promise.all(
      res?.data?.total_fund_data?.map((value) => {
        const formattedDate = formatDate(value.createdAt);
        const investorName = value?.user?.f_name + " " + value?.user?.l_name;
        const contact_no = value?.user?.contact_no;
        const type = value?.type;
        const utrId = value?.utr_id;
        const amount = value?.amount;

        return [formattedDate, investorName, contact_no, type, utrId, amount];
      }),
    );
    const { content, type, name } = ExportMethod.excel(
      exportData,
      header,
      "Investor Ledger",
    );
    const blob = new Blob([content], { type });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = name;
    link.click();
  };

  const handleExportTrade = async () => {
    const header = [
      { name: "Earning Date" },
      { name: "Investor Name" },
      { name: "Service No" },
      { name: "Segment" },
      { name: "Earning Amount" },
    ];

    // Use map without async, but await promises
    const exportData = await Promise.all(
      data?.total_fund_data?.map((value) => {
        const formattedDate = formatDate(value.createdAt);
        const investorName = value?.user?.f_name + " " + value?.user?.l_name;
        const contact_no = value?.user?.contact_no;
        const utrId = value?.utr_id;
        const amount = value?.amount;

        return [formattedDate, investorName, contact_no, utrId, amount];
      }),
    );
    const { content, type, name } = ExportMethod.excel(
      exportData,
      header,
      "Investor Ledger",
    );
    const blob = new Blob([content], { type });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = name;
    link.click();
  };

  const handleExportRefferal = async () => {
    const res = await getRefferalUserData(
      data?.user_id,
      getValues("from"),
      getValues("to"),
    );
    const header = [
      { name: "Payment Date" },
      { name: "Investor Name" },
      { name: "Service No" },
      { name: "Refferal Amount" },
    ];

    // Use map without async, but await promises
    const exportData = await Promise.all(
      res?.data?.total_refferal_earning_data?.map((value) => {
        const formattedDate = formatDate(value.createdAt);
        const investorName = value?.user?.f_name + " " + value?.user?.l_name;
        const contact_no = value?.user?.contact_no;
        const amount = value?.t_c;

        return [formattedDate, investorName, contact_no, amount];
      }),
    );
    const { content, type, name } = ExportMethod.excel(
      exportData,
      header,
      "Refferal Report",
    );
    const blob = new Blob([content], { type });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = name;
    link.click();
  };

  const handleExportProfit = async () => {
    const res = await getProfitUserData(
      data?.user_id,
      getValues("from"),
      getValues("to"),
    );
    const header = [
      { name: "Payment Date" },
      { name: "Investor Name" },
      { name: "Service No" },
      { name: "Type" },
      { name: "PnL Amount" },
    ];

    // Use map without async, but await promises
    const exportData = await Promise.all(
      res?.data?.total_profit_distribution_data?.map((value) => {
        const formattedDate = formatDate(value.createdAt);
        const investorName = value?.user?.f_name + " " + value?.user?.l_name;
        const contact_no = value?.user?.contact_no;
        const type = value?.type;
        const amount = type === "Profit" ? value?.t_c : value?.t_d;

        return [formattedDate, investorName, contact_no, type, amount];
      }),
    );
    const { content, type, name } = ExportMethod.excel(
      exportData,
      header,
      "Profit Report",
    );
    const blob = new Blob([content], { type });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = name;
    link.click();
  };

  const [setup, setSetup] = useState([]);
  const getMastersData = async () => {
    const res = await getSetup();
    await setSetup(res?.data);
  };

  useEffect(() => {
    getMastersData();
  }, []);
  const convertrate = (amount) => {
    const inr = Number(amount);
    const rate = Number(setup.withdraw_exchange_rate);
    const total = (inr * rate).toFixed(2);
    return total;
  };
  return (
    <>
      <div className="search-investor ">
        <p className="sub">User Wise Report</p>
        <Row className="mt-3">
          <Col xxl={3} xl={3} lg={4}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <p className="sub">Service Number</p>
              <div>
                <input
                  type="text"
                  id="firstName"
                  {...register("service_number", {
                    required: true,
                  })}
                  className={`form-control ${
                    errors.service_number ? "is-invalid" : ""
                  }`}
                />
              </div>
            </form>
            <Datepicker
              reset={reset}
              getValues={getValues}
              setValue={setValue}
              className="mt-3"
            />
            <div className="d-flex">
              <div className="search" onClick={handleSubmit(onSubmit)}>
                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                <p>Search</p>
              </div>
              <div
                className="search ms-1"
                onClick={() => {
                  reset();
                  getData();
                }}
              >
                {/* <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" /> */}
                <p>Reset</p>
              </div>
            </div>
          </Col>
          <Col xxl={9} xl={9} lg={12}>
            <div className="search-transaction mt-3">
              <Row>
                <Col xxl={4} xl={4} lg={4}>
                  <div className="main-inves">
                    <div className="">
                      <div>
                        <b>Total Available Fund</b>
                        <a
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => handleExportFunds()}
                        >
                          <p>{convertrate(data?.total_fund_users || 0)}</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xxl={4} xl={4} lg={4}>
                  <div className="main-inves">
                    <div className="">
                      <div>
                        <b>Till Date Trade Earning</b>
                        <a
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          <p>{convertrate(data?.total_trade_earning || 0)}</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xxl={4} xl={4} lg={4}>
                  <div className="main-inves">
                    <div className="">
                      <div>
                        <b>Till Date Refferal Earning</b>
                        <a
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => handleExportRefferal()}
                        >
                          <p>
                            {convertrate(data?.total_refferal_earning || 0)}
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xxl={4} xl={4} lg={4}>
                  <div className="main-inves">
                    <div className="">
                      <div>
                        <b>Till Date Profit Distribution</b>
                        <a
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => handleExportProfit()}
                        >
                          <p>
                            {convertrate(data?.total_profit_distribution || 0)}
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default UserWiseReport;
